<div id="mainheader" class="fixed-top" *ngIf="!noHeader">
  <div class="d-flex flex-column">
    <!-- <app-header [demoIcon]="demoIconFlag"></app-header>
    <app-breadcrumb></app-breadcrumb> -->
    <div>
      <app-categorybar (emitValues)="getFilterValues($event)"></app-categorybar>
    </div>
  </div>
</div>
<div class="wrapper">
  <div class="top-section" [ngClass]="{'custom-margin': changefiltervalue(), 'alignsubmmited': !changefiltervalue()}">
    <div class="left-section d-flex">
    </div>
    <div style="min-width: fit-content;" class="ApprovalButtons mt-2"
      *ngIf="this.available == 1 && !LeadershipRole && CMPID == 3">
      <div>
        <button class="btn custom_btn primary_btn_base mt-2" (click)="openInfoDialog()"
          [disabled]="enableApproveButton()">
          Approve
        </button>
      </div>
      <div class="mt-3">
        <label class="checkbox-label ml-2">
          <input type="checkbox" class="SelectedAllCheckBox ml-2" [checked]="isSelectAll"
            (change)="selectAll($event)" />
          <span class="SelectedAll ml-2">Select All</span>
        </label>
      </div>
    </div>
    <div class="tiles-main-section row" style="margin-right: 160px;">
      <div class="filter-section " style=" align-items: center; margin-bottom: 3px; display: flex;">
        <div class="align_length">
          <span *ngIf="!isSearchFiltered && subCompetencyId==0 && available==-1 && !isAdvancedFilterApplied">Total Count
            : {{total}}
            <sup class="material-symbols-outlined fs-16 info" [ngbTooltip]="tooltipTemplate"
              tooltipClass="mytooltip custom_tooltip" placement="right">
              info
            </sup>
          </span>
          <ng-template #tooltipTemplate>
            <span>
              Available Count: {{ activeEmployeesCount }}<br>
              Resigned Count: {{ inActiveEmployeesCount }}
            </span>
          </ng-template>
          <span *ngIf="isSearchFiltered || subCompetencyId!=0 || available!=-1 || isAdvancedFilterApplied" class="filteredtc-color">Filtered
            Total Count : {{total}} 
            <sup class="material-symbols-outlined fs-16 info" [ngbTooltip]="tooltipTemplate"
              tooltipClass="mytooltip custom_tooltip" placement="right">
              info
            </sup>
          </span>
        </div>

        <div class="d-flex mt-3" style="min-width:45%;margin-right: -43px; margin-left:20px;padding: left -6px;">
          <div class="search-text d-flex">

            <input type="search" class="form-control w-100 border-0" [(ngModel)]="searchText"
              placeholder="Search for Employee by Name or Id..." (keyup.enter)="searchButton()"
              [class.searchClose]="searchText == ''" />
            <button type="submit" class="search-icon" (click)="clearSearchText()" *ngIf="searchText != ''">
              <i class="fa fa-times icon"></i>
            </button>
            <button type="submit" class="search-icon" (click)="searchButton()">
              <i class="fa fa-search icon"></i>
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end mr-3 mt-3" style="min-width: fit-content;">

          <div class="select-filter" style="min-width: 90px;margin-right: -50px; margin-left: 3rem;">

          </div>
          <div class="select-filter" style="min-width: 90px;margin-left: -2.5rem;">
            <span class="filter-text mb-1"> Filter&nbsp;by:</span>
            <div *ngIf="CMPID == 3">
              <select style="width:150px;margin-left: 13px;;margin-top: 3px;" class="form-control" #categorySelection
                [(ngModel)]="available" (change)="filterChange(categorySelection.value)">
                <option value="-1">All Status</option>
                <option value="2">Not Submitted</option>
                <option value="1">Submitted</option>
                <option value="3">Approved</option>
                <option value="4">Rejected</option>
              </select>
            </div>
          </div>
        </div>

        <div *ngIf="CMPID == 1" style="width:110px">
          <select class="form-control" #categorySelection [(ngModel)]="available"
            (change)="filterChange(categorySelection.value)">
            <option [value]="5">Total</option>
            <option [value]="1">Talent Pool</option>
            <option [value]="2">Billable</option>
            <option [value]="3">Notice Period</option>
          </select>
        </div>


        <div *ngIf="CMPID == 2" style="min-width: 50%">
          <select class="form-control" #categorySelection [(ngModel)]="available"
            (change)="filterChange(categorySelection.value)">
            <option [value]="1">Planned certifications</option>
            <option [value]="2">Completed certifications</option>
          </select>
        </div>

        <select #subCompeSelection (change)="subCompetencyChange(subCompeSelection.value)" [(ngModel)]="subCompetencyId"
          class="form-control select-filter subCompDropdown">
          <option value="0" class="option">All Sub Competencies</option>
          <option *ngFor="let subComp of subCompetencies" class="option" [value]="subComp.id">
            {{ subComp.name }}
          </option>
        </select>


        <!-- <select style="min-width: 90px;margin-right: 13px;" #countrySelection [(ngModel)]="CountrySelected"
          class="form-control select-filter mt-3" (change)="ChangeCountry()">
          <option [value]="empty" class="option">All</option>
          <option *ngFor="let country of CountriesList" class="option" [value]="country">
            {{ country }}
          </option>
        </select> -->

        <!-- <select class="form-control select-filter mt-3" style="min-width: 90px;margin-right:13px;" #categorySelection
          [(ngModel)]="CertificationStatus" (change)="ChangeCertStatus()">
          <option [value]="-1" class="option">All</option>
          <option [value]="0" class="option">Planned certifications</option>
          <option [value]="1" class="option">Completed certifications</option>
        </select> -->
        <!-- <div>
          <i class="fas fa-sharp fa-filter filterList ml-2" (click)="filterEnable()"></i>
          <div *ngIf="isFilter" class="filter-box">

            <div class="col">
              <div class="row">
                <div>
                  <h3 *ngIf="CMPID == 3" class="filter-text">Resume :</h3>
                </div>

                <div *ngIf="CMPID == 3" style="margin-left: 3.5rem;">
                  <select *ngIf="CMPID == 3" class="form-control droplist" #categorySelection
                    [(ngModel)]="Resumestatus">
                    <option value="0" class="option">All</option>
                    <option value="1" class="option">Uploaded</option>
                    <option value="2" class="option">Not Uploaded</option>
                  </select>
                </div>
              </div>
              <div class="row" style="margin-top: 1rem;">
                <div>
                  <h3 class="filter-text">Country :</h3>
                </div>
                <div style="margin-left: 3.5rem;">
                  <select #countrySelection [(ngModel)]="CountrySelected" class="form-control droplist">
                    <option [value]="empty" class="option">All</option>
                    <option *ngFor="let country of CountriesList" class="option" [value]="country">
                      {{ country }}
                    </option>
                  </select>

                </div>


              </div>
              <div class="row" style="margin-top: 1rem;">
                <div>
                  <h3 class="filter-text">Certifications :</h3>
                </div>
                <div style="margin-left: 1rem;">
                  <select class="form-control droplist" #categorySelection [(ngModel)]="CertificationStatus">
                    <option [value]="-1" class="option">All</option>
                    <option [value]="0" class="option">Planned certifications</option>
                    <option [value]="1" class="option">Completed certifications</option>
                  </select>

                </div>



              </div>
              <div class="row" style="margin-top: 1rem;">
                <div>
                  <h3 class="filter-text">Availability :</h3>
                </div>
                <div style="margin-left: 2rem;">
                  <select #countrySelection [(ngModel)]="AvailabilityStatus" class="form-control droplist">
                    <option [value]="-1" class="option">All</option>
                    <option [value]="0" class="option">Billable</option>
                    <option [value]="1" class="option">Non-Billable</option>
                  </select>

                </div>


              </div>
              <div class="row" style="margin-top: 1rem;">
                <div>
                  <h3 class="filter-text">Resigned :</h3>
                </div>
                <div style="margin-left: 2.5rem;">
                  <select #countrySelection [(ngModel)]="ResignedStatus" class="form-control droplist">
                    <option [value]="-1" class="option">All</option>
                    <option [value]="1" class="option">Yes</option>
                    <option [value]="0" class="option">No</option>
                  </select>

                </div>


              </div>
              <div class="mt-3" style="margin-left: -1.5rem;">
                <label class="checkbox-label ml-0">
                  <input type="checkbox" class="SelectedAllCheckBox ml-2" [checked]="isNotUpdatedSince3Months"
                    (change)="NotUpdatedSince3Months($event)" />
                  <span class="SelectedAll ml-2">Unupdated employees past quarter</span>
                </label>
              </div>
            </div>
            <div style="margin-left: 55%; margin-top: 1rem;">
              <button class="btn cancelbtn" (click)="closeFilter()">
                Cancel
              </button>
              <button class="btn applyfilterbtn" (click)="ApplyFilter()">Apply</button>
            </div>

          </div>


        </div> -->

        <div class="btn custom_btn primary_btn_base export-btn  ml-3" (click)="exportExcel()"
          style="min-width: fit-content;">
          Export
        </div>
        <div class="">
          <div class="row">
            <div class="col-md-9 main-content" style="position: absolute; margin-top: -25px;">
              <i class="fas fa-sharp fa-filter filterList ml-2" data-toggle="modal" data-target="#exampleModal"></i>

            </div>


          </div>
        </div>

        <!-- <button type="button" id="sidebarCollapse" class="btn menu-icon">
          <span class="material-symbols-outlined" style="margin-top: 10px;" >
            arrow_back
            </span>
        </button> -->

      </div>
    </div>
  </div>
  <hr class="line-break" />
  <div class="mt-4">
    <app-skill-repo-employee-tiles *ngIf="showCards && data.length > 0" [data]="data"
      [comingFromGlobalSearch]="false"></app-skill-repo-employee-tiles>
      <div *ngIf="showCards && data.length === 0" class="no-data-message">
        <img src ="../../../assets/images/no_data.png" height="150px" >
        <br>
        <h4>No Result Found</h4>
     </div>
  </div>
  <div *ngIf="showviewMore" class="view-more-section pb-2 pt-3">
    <div class="view-more" (click)="viewMore()">View more</div>
  </div>
  <ng-template let-data #myInfoDialog>
    <h1 mat-dialog-title class="popup-title w-100">
      Confirmation
    </h1>
    <div mat-dialog-content class="popup-content">
      {{ data }}
    </div>
    <div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
      <button [mat-dialog-close]="true" class=" popup-okbutton btn" (click)="ApproveAll()">
        Submit
      </button>
      <button mat-dialog-close class=" popup-cancelbutton btn ml-2" (click)="setCheckedEmployeesNull()">
        Close
      </button>
    </div>
  </ng-template>
</div>
<div class="modal fade pr-0" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog m-0 ml-auto" role="document">
    <div class=" modal-content ">
      <div class="modal-header">
        <button type="button" class="close m-0 p-0" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" class="cancel">&times;</span>
        </button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <div>
          <h2 class="advance">Advance Filter</h2>
        </div>

      </div>
      <div class="modal-body">
        <div class="sidebar">
          <!-- <div class="row filter-title">
            <div style="position: absolute; margin-top: 23px; marg&nbsp;in-left: 10px;"><i class="fa fa-times" style='font-size:24px' (click)="toggleSidebar()"></i></div> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            
          </div> -->

          <mat-accordion multi="true">
            <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" (opened)="isSidebarOpen = true"
              [expanded]="true" hideToggle>
              <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                <mat-panel-title class="h3 fw-450 field_heading font">
                  Profile Uploaded
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" #categorySelection>
                <div class="area-section">
                  <input type="radio" style="background-color:#42439D" name="index" value="0"
                    [checked]="getCheckedResume(0)" (change)="updatedResume($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">All</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="index" value="1" [checked]="getCheckedResume(1)"
                    (change)="updatedResume($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Uploaded</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="index" value="2" [checked]="getCheckedResume(2)"
                    (change)="updatedResume($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Not Uploaded</span>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" (opened)="isSidebarOpen = true"
              [expanded]="true" hideToggle>
              <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                <mat-panel-title class="h3 fw-500 field_heading font">
                  Region
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" #countrySelection>
                <div class="area-section">
                  <input type="checkbox" [checked]="getCheckedCountry('')" (change)="updatedCountry($event,'')" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">All</span>
                </div>
                <div class="area-section" *ngFor="let country of CountriesList">
                  <input type="checkbox" [checked]="getCheckedCountry(country)"
                    (change)="updatedCountry($event,country)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">{{country}}</span>
                </div>
                <!-- <div class="area-section">
                  <input type="radio" name="index" value="2"/>&nbsp;&nbsp;&nbsp;<span style="font-size: 24px;">No</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="index" value="0"/>&nbsp;&nbsp;&nbsp;<span style="font-size: 24px;">None</span>
                </div> -->
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" [expanded]="true" hideToggle>
              <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                <mat-panel-title class="h3 fw-500 field_heading font">
                  Certifications
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" #categorySelection>
                <div class="area-section">
                  <input type="radio" name="Certify" value="-1" [checked]="getCheckedCertifications(-1)"
                    (change)="updatedCertification($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">All</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="Certify" value="1" [checked]="getCheckedCertifications(1)"
                    (change)="updatedCertification($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Completed</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="Certify" value="0" [checked]="getCheckedCertifications(0)"
                    (change)="updatedCertification($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Planned</span>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" (opened)="isSidebarOpen = true"
              [expanded]="true" hideToggle>
              <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                <mat-panel-title class="h3 fw-500 field_heading font">
                  Availability
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" #countrySelection>
                <div class="area-section">
                  <input type="radio" name="available" value="-1" [checked]="getCheckedAvailability(-1)"
                    (change)="updatedAvailability($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">All</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="available" value="0" [checked]="getCheckedAvailability(0)"
                    (change)="updatedAvailability($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Billable</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="available" value="1" [checked]="getCheckedAvailability(1)"
                    (change)="updatedAvailability($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Non-Billable</span>
                </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mt-3 mat-panel-expansion matexpansions" (opened)="isSidebarOpen = true"
              [expanded]="true" hideToggle>
              <mat-expansion-panel-header class="m-0 bder-bottom accordion_panel_header">
                <mat-panel-title class="h3 fw-500 field_heading font">
                  Resigned
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row" #countrySelection>
                <div class="area-section">
                  <input type="radio" name="resign" value="-1" [checked]="getCheckedResigned(-1)"
                    (change)="updatedResigned($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">All</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="resign" value="1" [checked]="getCheckedResigned(1)"
                    (change)="updatedResigned($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">Yes</span>
                </div>
                <div class="area-section">
                  <input type="radio" name="resign" value="0" [checked]="getCheckedResigned(0)"
                    (change)="updatedResigned($event)" />
                  &nbsp;&nbsp;&nbsp;<span class="filterOptions">No</span>
                </div>
              </div>
            </mat-expansion-panel>

          </mat-accordion>
          <div class="">
            <label class="checkbox-labels ml-0" style="margin-top: 20px;">
              <input type="checkbox" class="SelectedAllCheckBox ml-2" [checked]="isNotUpdatedSince3Months"
                (change)="NotUpdatedSince3Months($event)" />
              <span class="SelectedAll ml-2">Profiles not updated in 3 months.</span>
            </label>
          </div>
          <div class="">
            <label class="checkbox-labels my-8" style="margin-top: 50px;">
              <input type="checkbox" class="SelectedAllCheckBox ml-2" [checked]="isSme" (change)="SME($event)" />
              <span class="SelectedAll ml-2">SME</span>
            </label>
          </div>
          <div class="filteractions">
            <button class="btn cancelbtn" data-dismiss="modal">
              Close
            </button>
            <button class="btn cancelbtn ml-2" (click)="ClearFilter()">
              Clear
            </button>
            <button class="btn applyfilterbtn" data-dismiss="modal" (click)="ApplyFilter()">Apply</button>
          </div>


        </div>
      </div>

    </div>
  </div>
</div>